import { Component } from "../component"
import { scrollLoop } from "../helpers/scroll-loop"

export class SectionNavigationBar extends Component {
  constructor(props) {
    super(props)

    this.dynamicClasses = {
      visible: "-visible",
      absolute: "-absolute",
    }

    this.parentSection = this.$el.parentElement
  }

  ui() {
    return {}
  }

  handleScroll(position) {
    const { visible, absolute } = this.dynamicClasses
    const parentViewportTop = this.parentSection.getBoundingClientRect().top
    const parentViewTopOffset = this.$el.dataset.offset || 0
    const isVisible = parentViewportTop <= parentViewTopOffset
    const isAbsolute =
      this.parentSection.offsetHeight +
        this.parentSection.getBoundingClientRect().top -
        100 <=
      0

    // console.log(parentViewportTop)

    if (isVisible && !this.$el.classList.contains(visible)) {
      this.$el.classList.add(visible)
    } else if (!isVisible && this.$el.classList.contains(visible)) {
      this.$el.classList.remove(visible)
    }
    if (isAbsolute && !this.$el.classList.contains(absolute)) {
      this.$el.classList.add(absolute)
    } else if (!isAbsolute && this.$el.classList.contains(absolute)) {
      this.$el.classList.remove(absolute)
    }
  }

  created() {
    if (window.innerWidth > 1024) {
      scrollLoop(() => {
        this.handleScroll(window.pageYOffset)
      })
    }
  }
}
